import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUp: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.16 11.92h15.68L8 4.08z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUp
